//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    
    data(){
        return {
            info:{
                wait_rebate:'0.00',
                hand_fee:'0.00',
                nickname:'',
                name:'',
                ids:'',
            },
            ids:'',
            type:0,
            amount:0,
            status:true,
        }
    },
    mounted(){
        this.ids = this.$route.query.ids;
        this.type = this.$route.query.type;
        this.withdrawMoney();
    },
    methods: {
        withdrawMoney(){
            this.$api.withdrawMoney({ids:this.ids,type:this.type}).then((res)=>{
                if(res){
                    this.info = res.data;
                    this.amount = this.info.wait_withdraw;
                }
            });
        },
        submitWithdraw(){
            if(!this.status){
                return false;
            }
            this.status = false;
            if(!this.info.name){
                this.$func.showToast('请输入真实姓名');
                return false;
            }
            if(this.amount <= 0){
                this.$func.showToast('提现金额不正确');
                return false;
            }
            if(this.amount > this.info.wait_withdraw){
                this.$func.showToast('可提现金额不足');
                return false;
            }
            if(this.amount > 2000){
                this.$func.showToast('单次提现限额2000元');
                return false;
            }
            this.$func.confirm('确认提交申请？','提示',()=>{
                this.checkWithdrawAuthorization();
            })
        },
        checkWithdrawAuthorization(){
            this.$api.withdrawAuthorization({}).then((res)=>{
                if(!res){
                    this.status = true;
                    return false;
                }
                if(res.data.authorized){
                    this.doSubmitWithdraw();
                    return;
                }
                this.openWithdrawAuthorization(res.data);
            });
        },
        openWithdrawAuthorization(data){
            if(!data.package_info){
                this.status = true;
                this.$func.showToast('微信授权参数异常');
                return false;
            }
            const onBridgeReady = () => {
                WeixinJSBridge.invoke('requestMerchantTransfer', {
                    mchId: data.mch_id,
                    appId: data.app_id,
                    package: data.package_info
                }, (res) => {
                    if(res.err_msg == 'requestMerchantTransfer:ok'){
                        this.$api.bindWithdrawAuthorization({out_authorization_no:data.out_authorization_no}).then((res)=>{
                            if(res){
                                this.doSubmitWithdraw();
                            }else{
                                this.status = true;
                            }
                        });
                    }else{
                        this.status = true;
                        this.$func.showToast('未完成微信提现授权');
                    }
                });
            };
            if (typeof WeixinJSBridge == "undefined"){
                if(document.addEventListener){
                    document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
                }else if(document.attachEvent){
                    document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                    document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
                }
            }else{
                onBridgeReady();
            }
        },
        doSubmitWithdraw(){
            this.$api.submitWithdraw({name:this.info.name,ids:this.ids,type:this.type,amount:this.amount}).then((res)=>{
                this.status = true;
                if(res){
                    setTimeout(()=>{
                        this.$router.push({path: '/withdrawComplete', query: {grade: res.data.grade}});
                    }, 300);
                }
            });
        },
    },
}



// WEBPACK FOOTER //
// ./src/pages/withdraw.vue